import * as _ from 'lodash';
import * as React from 'react';
import { Button, ButtonGroup, Dropdown } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';

import {
  closeNotificationPanel,
  dismissAllNotifications,
  dismissNotification,
} from '../../actions/notificationActions';
import { Notification, NotificationType } from '../../models/notification';
import { AppState } from '../../models/state/appState';
import LiveFormattedDateTime from '../ui/LiveFormattedDateTime';

export default function NotificationList() {
  const dispatch: Dispatch<any> = useDispatch();
  const isPanelOpen = useSelector<AppState, boolean>((state) => state.notifications.isPanelOpen);
  const unorderedNotifications = useSelector<AppState, Notification[]>((state) => state.notifications.notifications);
  const notifications = _.orderBy(unorderedNotifications, ['raisedOn'], ['desc']);

  const onDismissTypeClicked = (e: React.SyntheticEvent<HTMLElement>) => {
    e.preventDefault();
    dispatch(dismissAllNotifications(e.currentTarget.dataset.notificationtype as NotificationType));
  };

  const renderNotificationItem = (notification: Notification) => (
    <div key={`notification-${notification.uid}`} className={`vmo-notification-item vmo-notification-${notification.type}`}>
      <div>
        <span className="vmo-notification-title">{notification.title}</span>
        <span className="vmo-notification-time">
          <LiveFormattedDateTime value={notification.raisedOn} />
        </span>
        <span className="vmo-notification-detail">{notification.detail}</span>
      </div>
      <div className="btn-group">
        <button
          type="button"
          data-notificationid={notification.uid}
          onClick={(e: React.SyntheticEvent<HTMLButtonElement>) => {
            e.preventDefault();
            const idString = e.currentTarget.dataset.notificationid;
            if (!idString) {
              return;
            }

            dispatch(dismissNotification(parseInt(idString, 10)));
          }}
          className="btn btn-default"
        >
          dismiss
        </button>
        {notification.action && (
          <button type="button" onClick={notification.action}>
            {notification.actionLabel || 'Action'}
          </button>
        )}
      </div>
    </div>
  );

  return (
    <div className={`vmo-notification-panel${isPanelOpen ? ' vmo-open' : ''}`}>
      <div>
        <div className="header">
          <button
            type="button"
            className="btn btn-link"
            onClick={() => dispatch(closeNotificationPanel())}
            aria-label="Close notifications"
          >
            <i className="fa-solid fa-fw fa-circle-xmark" aria-hidden="true"></i>
          </button>
          <span>Notifications</span>
        </div>
        <div className="content">
          <div>
            <Dropdown as={ButtonGroup} className="vmo-dismiss-dropdown">
              <Button
                variant="default"
                onClick={(e: React.SyntheticEvent<HTMLButtonElement>) => {
                  e.preventDefault();
                  dispatch(dismissAllNotifications());
                }}
              >
                Dismiss All
              </Button>
              <Dropdown.Toggle
                split
                variant="default"
                id="dismiss-notification-type"
                aria-label="Choose notification type to dismiss"
              >
                <i className="fa-solid fa-chevron-down" aria-hidden="true"></i>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item href="#" onClick={onDismissTypeClicked} data-notificationtype="success">
                  Completed
                </Dropdown.Item>
                <Dropdown.Item href="#" onClick={onDismissTypeClicked} data-notificationtype="info">
                  Information
                </Dropdown.Item>
                <Dropdown.Item href="#" onClick={onDismissTypeClicked} data-notificationtype="warning">
                  Warning
                </Dropdown.Item>
                <Dropdown.Item href="#" onClick={onDismissTypeClicked} data-notificationtype="error">
                  Error
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            <div className="vmo-notification-list">
              <div>
                {!isPanelOpen
                  ? null
                  : notifications.length > 0
                    ? notifications.map(renderNotificationItem)
                    : (
                      <span className="vmo-empty">
                        <i className="fa-solid fa-fw fa-circle-info"></i>
                        <span>No notifications.</span>
                      </span>
                    )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
